import { Component, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { Observable } from "rxjs";
import { BaseDialogActionData, ButtonColor, CommonActionKey } from "common";
import { ConfirmChangesDialogData } from "./confirm-changes-dialog.model";

@Component({
    selector: "ifb-confirm-changes-dialog",
    templateUrl: "./confirm-changes-dialog.component.html",
    styleUrls: ["./confirm-changes-dialog.component.scss"],
    standalone: false
})
export class ConfirmChangesDialogComponent {
  actions: BaseDialogActionData[] = [
    { actionKey: CommonActionKey.Cancel, label: 'Cancel', buttonColor: ButtonColor.Default },
    { actionKey: CommonActionKey.Confirm, label: 'Confirm', buttonColor: ButtonColor.Primary },
  ];

  constructor(
    public dialogRef: MatDialogRef<ConfirmChangesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmChangesDialogData
  ) { }

  static show(
    dialog: MatDialog,
    data: ConfirmChangesDialogData,
  ): Observable<boolean> {
    return dialog
      .open(ConfirmChangesDialogComponent, {
        data,
        closeOnNavigation: true,
      })
      .afterClosed();
  }

  onActionClicked(actionData: BaseDialogActionData): void {
    if (actionData.actionKey === CommonActionKey.Confirm) {
      this.dialogRef.close(true);
      return;
    }

    this.dialogRef.close(false);
  }
}

